import { Navigation } from './pages/Navigation';

export default Navigation;